import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardContent from "../atoms/DashboardContent";
import { useParams } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { handleChange, handleSubmit } from "../../atoms/Upsert";
import Input from "../../atoms/Input";
import Select from "../../atoms/Select";
import ButtonCancel from "../../atoms/ButtonCancel";
import ButtonSave from "../../atoms/ButtonSave";
import * as generalHelper from "../../../helpers/generalHelper";
import { getStatuses } from "../../../store/slice/statusSlice";
import { getDevices } from "../../../store/slice/deviceSlice";
import { getDeviceTypes } from "../../../store/slice/deviceTypeSlice";

import {
    getDeviceTypeLink,
    insertDeviceTypeLink,
    updateDeviceTypeLink,
} from "../../../store/slice/deviceTypeLinkSlice";
import routes from "../constants/routes";

export default function (props) {
    const dispatch = useDispatch();
    const [values, setValues] = useState({});
    const statuses = useSelector((state) => state.status.rows);
    const devices = useSelector((state) => state.device.rows);
    const deviceTypes = useSelector((state) => state.deviceType.rows);
    const [redirect, setRedirect] = useState(false);
    const { id } = useParams();

    React.useEffect(() => {
        dispatch(getDevices({}));
        dispatch(getDeviceTypes({}));
        dispatch(getStatuses({ type: "Default" }));
        if (id) {
            dispatch(getDeviceTypeLink({ id: id })).then((response) => {
                setValues(response.payload);
            });
        }
    }, []);

    function Content(props) {
        return (
            <div className="card card-primary">
                <form
                    type="post"
                    onSubmit={(event) => {
                        handleSubmit(event, {
                            id: id,
                            values: values,
                            functions: {
                                insert: insertDeviceTypeLink,
                                update: updateDeviceTypeLink,
                            },
                            callback: {
                                function: setRedirect,
                                params: `${routes.index}${routes.deviceTypeLink.root}`,
                            },
                            dispatch: dispatch,
                        });
                    }}
                >
                    <div className="card-body row">
                        <div className="col-sm-6 col-md-4">
                            <Select
                                label="Device"
                                name="device_id"
                                options={devices}
                                value={values.device_id}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <Select
                                label="Device Type"
                                name="device_type_id"
                                options={deviceTypes}
                                value={values.device_type_id}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <Select
                                label="Status"
                                name="status_id"
                                options={statuses}
                                value={values.status_id}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-right">
                        <ButtonCancel /> <ButtonSave />
                    </div>
                </form>
            </div>
        );
    }

    return (
        <div>
            {redirect && <Navigate to={redirect} />}
            <DashboardContent
                title={id ? "Edit Device Type" : "Create Device Type"}
                icon="fa fa-link"
                content={Content(props)}
                breadcrumb={[
                    {
                        label: "Devices",
                        to: `${routes.index}${routes.device.root}`,
                    },
                    {
                        label: "Device Type Links",
                        to: `${routes.index}${routes.deviceTypeLink.root}`,
                    },
                    { label: id ? "Edit" : "New" },
                ]}
            />
        </div>
    );
}
